/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setupprofileorganizertitle3Inputs */

const en_setupprofileorganizertitle3 = /** @type {(inputs: Setupprofileorganizertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizer`)
};

const de_setupprofileorganizertitle3 = /** @type {(inputs: Setupprofileorganizertitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstalter`)
};

/**
* | output |
* | --- |
* | "Organizer" |
*
* @param {Setupprofileorganizertitle3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const setupprofileorganizertitle3 = /** @type {((inputs?: Setupprofileorganizertitle3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setupprofileorganizertitle3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_setupprofileorganizertitle3(inputs)
	return de_setupprofileorganizertitle3(inputs)
});
export { setupprofileorganizertitle3 as "setupProfileOrganizerTitle" }